/**
 * Types to messages
 */
export const MESSAGE_CLEAR = '[MESSAGE] CLEAR';
export const MESSAGE_SET = '[MESSAGE] SET MESSAGE';